module.exports = __webpack_public_path__ + "img/information_blue.svg";